import { render, staticRenderFns } from "./duplicateDialog.vue?vue&type=template&id=49c15b50"
import script from "./duplicateDialog.vue?vue&type=script&lang=js"
export * from "./duplicateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports